import "./PCPNav.scss";
import "./PCPNavMobile.scss";
import { PCPNavStructure } from "../PCPNavStructure";

function PCPNav({ activeNav, onSelect }) {
  return (
    <>
      <div className="pcp-nav-main-container">
        <div className="pcp-nav-container">
          {PCPNavStructure.map((item) => (
            <div
              key={item.id}
              className={`pcp-nav-wrapper ${
                activeNav === item.id ? "active" : ""
              }`}
              onClick={() => onSelect(item.id)}
            >
              <img
                src={item.icon}
                className="pcp-nav-wrapper-img"
                alt={item.name}
              />
              <p>{item.name.toUpperCase()}</p>
              {activeNav === item.id && (
                <div className="pcp-black-indicator"></div>
              )}
            </div>
          ))}
        </div>
        <div className="pcp-gray-line-div"></div>
      </div>
    </>
  );
}

export default PCPNav;
